<div class="tutorial_start"></div>
<app-tutorial-step *ngIf="current_step.focus_on != ''" [focus_on]="current_step.focus_on+'.tutorialactive'" [icon]="current_step.icon"
                   [text]="current_step.text" [tutorial]="this"></app-tutorial-step>
<div *ngIf="current_step.focus_on != ''" class="tutorial_skip_button" style="background-color: #3b484d; padding: 10px">
  <button (click)="setSeen()" mat-flat-button style="margin-right: 10px">Verstanden</button>
  <button (click)="disable()" mat-raised-button style="margin-right: 10px" color="danger">Deaktivieren</button>
  <button (click)="disableForNow()" mat-raised-button color="warn">Jetzt nicht mehr anzeigen</button>
</div>
